"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorForm = void 0;
var tslib_1 = require("tslib");
var input_1 = require("../../../components/input/input");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var store_1 = require("../../../store");
var user_card_1 = require("../../user.assign.modal/user.card");
var form_palette_1 = require("../form.palette");
var form_field_editor_1 = require("./form.field.editor");
var form_field_tree_view_1 = require("./form.field.tree.view");
var form_info_panel_style_1 = require("./form.info.panel.style");
var USER_CARD_CTX = { readonly: true };
var FormFieldEditorForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorForm, _super);
    function FormFieldEditorForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFieldEditorForm.prototype.getDescriptionState = function () {
        var _this = this;
        var displayState = this.state.get('description');
        if (displayState == null) {
            displayState = this.state.child(i18n_1.T.FORM_FIELD_DESCRIPTION, 'description');
            displayState.isLabelShown = true;
            displayState.isRequired = true;
            displayState.onValue(function (val) { return _this.field.Mutator.description(val); });
            displayState.setValue(this.field.description);
        }
        displayState.readOnly = this.isLocked || !this.designer.isEditing;
        return displayState;
    };
    FormFieldEditorForm.prototype.viewTree = function () {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    };
    FormFieldEditorForm.prototype.viewInfo = function () {
        var _this = this;
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.container }, [
            input_1.Input.view(this.getTitleState()),
            input_1.Input.view(this.getDescriptionState()),
            (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.section.container }, [
                this.field.updatedAt != null ? this.viewOption(i18n_1.T.COLLECTION_UPDATED_AT, services_1.Services.DateTime.formatDateTime(this.field.updatedAt)) : null,
                this.viewPLASupport(),
                this.viewUserInfo()
            ]),
            form_palette_1.FormDesignerPalette.view(function (type) { return _this.designer.createField(_this.field, type); }, this.depth)
        ]);
    };
    FormFieldEditorForm.prototype.viewUserInfo = function () {
        if (this.field.updatedBy == null) {
            return null;
        }
        var updatedBy = store_1.AppStore.UserProfile.get(this.field.updatedBy);
        if (updatedBy == null) {
            return null;
        }
        return this.viewOption(i18n_1.T.COLLECTION_UPDATED_BY, user_card_1.UserCard.viewChip(updatedBy, USER_CARD_CTX));
    };
    Object.defineProperty(FormFieldEditorForm.prototype, "isCloneable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FormFieldEditorForm.prototype.viewPLASupport = function () {
        var options = this.field.metadata && this.field.metadata.options;
        if (options == null) {
            return null;
        }
        if (options.spidacalc != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_SPIDACALC));
        }
        if (options.ocalc != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_OCALC));
        }
        if (options.dds != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_DDS));
        }
        if (options.poleforeman != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_POLEFOREMAN));
        }
        if (options.ikePoleForeman != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_IKE_POLEFOREMAN));
        }
        return null;
    };
    return FormFieldEditorForm;
}(form_field_editor_1.FormFieldEditor));
exports.FormFieldEditorForm = FormFieldEditorForm;
//# sourceMappingURL=form.field.editor.form.js.map